import { createAction } from '@reduxjs/toolkit';
import { RequestError, LatestCommunication, ServiceInfo } from 'types';

export const fetchLatestCommunication = createAction('latest-communication/fetch', (serviceInfo: ServiceInfo) => ({
  payload: undefined,
  meta: serviceInfo,
}));

export const fetchedLatestCommunication = createAction(
  'latest-communication/fetched',
  (data?: LatestCommunication, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);
export default {
  fetchLatestCommunication,
  fetchedLatestCommunication,
};
